<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div class="inner">
    <p *ngIf="message">{{message}}</p>
    <p *ngIf="!message">{{'upgradeModal.featureAvailable' | translate:{plan: (targetPlan || 'pro')} }}</p>
    <ion-button color="secondary" (click)="upgrade()">{{'billing.upgradeNow' | translate}}</ion-button>
  </div>
</ion-content>
